/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Kamukama Denis",
  title: "Hi all, I'm Denis",
  subTitle: emoji(
    "A passionate Software developer with a knack for solving complex problems. My journey in the world of coding started eons ago, I thrive on challenges and continuously strive to expand my skill set.Currently experienced in building Web and Mobile applications with Android / ASP.NET Core / Blazor / .Net Maui and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1S0lcQtQitg2IFRkhtaWlwe7kGvqxAcDe/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/denismichealk",
  linkedin: "https://www.linkedin.com/in/denis-kamukama-5525a9117/",
  gmail: "kampd80@gmail.com",
  gitlab: "https://gitlab.com/denismichealk",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  stackoverflow: "https://stackoverflow.com/users/7450780/denis-micheal",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: ".Net",
      fontAwesomeClassname: "technology dotnet"
    },
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Golang",
      fontAwesomeClassname: "technology go"
    },
    {
      skillName: "Blazor",
      fontAwesomeClassname: "technology dotnet"
    },
    {
      skillName: "Rust",
      fontAwesomeClassname: "fab fa-rust"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "mithril",
      fontAwesomeClassname: "technology mithril"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "htmx",
      fontAwesomeClassname: "technology htmx"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Makerere University",
      logo: require("./assets/images/makerereLogo.png"),
      subHeader: "Bachelor of Science in Software Engineering",
      duration: "August 2013 - August 2017",
      desc: "Took courses about Software Engineering, Web Security, Operating Systems,OOP ...",
      descBullets: [
        "Second Class Degree"
      ]
    }
    // {
    //   schoolName: "Stanford University",
    //   logo: require("./assets/images/stanfordLogo.png"),
    //   subHeader: "Bachelor of Science in Computer Science",
    //   duration: "September 2013 - April 2017",
    //   desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
    //   descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    // }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "60%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Chap Chap Africa Limited",
      companylogo: require("./assets/images/chapchap_logo.png"),
      date: "February 2022 – Present",
      desc: "Revamping the legacy backend system that supports requests from the chap chap mobile app changing both software architecture from erlang to an event based driven system in c#.",
      descBullets: [
        "Revamping accounting logic of the legacy system to be fail safe and also adding fraud detection logic to alert Support on suspicious transactions.",
        "Developing financial reporting services to ease finance roles and the automation of manual tasks/processes.",
        "Developing reconciliation processes to capture any discrepancies between chap chap system and service providers.",
        "On boarding of new payment services to the chap chap mobile app such as URA,Umeme,LycaMobile, Tradelance,Nwsc,Wenreco and Kcca",
        "Reducing system downtimes and increasing up time and availability to 98.9% due to revamped system led to an increase in revenues for Chap Chap Africa limited."
      ]
    },
    {
      role: "Software Engineer",
      company: "Pegasus Technologies",
      companylogo: require("./assets/images/pegasus_logo.png"),
      date: "January 2019 – February 2022",
      desc: "Developing and maintaining IT solutions such as Payment collection Applications,SMS Applications,SOAP Payment Api's etcetera",
      descBullets:[
      "Develop payment collection systems that use various channels such as USSD service, ASP Net websites or android applications allowing clients to do collections easily and quick from their respective customers.",

      "Developing Bulk Sms systems where we develop Websites for clients to easily load Their Sms recipient’s base in order to disperse huge volumes of Sms messages to their target base.",
      
      "Implementation of conlog payment systems on *272# that enables users to pay their electricity bills.",
      
      "Development of the android application PegPay app that enables users to pay for utilities similar to services on shortcode *272#.",
      
      "Rebuild of the Stanbic Ecash system that enables Government officials and ministries to pay staff through their mobile money wallets.",
      
      "Device lending dubbed “Mtn Pay mpola mpola”  that enables customers with good mobile money profile rating to walk into any mtn licensed  shop and choose a device of their choice that they pay in installments over a period of 3 months.Rebuilding the XtrafLoat service which is a solution designed to allow MTN Agents Borrow Float when Low in order to transact off that credit.",
      
      "Developing and Maintaining Various Partner Projects with MTN & Ericsson such as Assisted Payments a solution that allows Users with any Network Line to pay for any Utility through any MTN Agent.",
      
      "Migration of mtn utility (NWSC,URA,UMEME) services from HSDP (Huawei service delivery platform) to the ECW (Ericsson Converged wallet) api.",
      
      "Developing Card Payment Gateway Solutions that are 3D secure and compliant with the PCI-DSS policies for example Merchant collection Systems that we have  set up with Partner Banks such as Stanbic Bank Uganda."]
    },
    {
      role: "Software Engineer Intern",
      company: "Web Info-Net Limited",
      companylogo: require("./assets/images/webinfo_logo.jpg"),
      date: "July 2016 – August 2017",
      desc: "Trained in computer security with focus on system penetration testing with the metasploit framework, computer software and hardware diagnostics, networking, router configuration with Packet Tracer, Linux (Ubuntu server) administration and Windows Server administration "
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/chapchap_logo.png"),
      projectName: "Chap Chap Agent",
      projectDesc: "An android application that enables and supports customers to perform mobile money,bank and bill payments",
      footerLink: [
        {
          name: "Download on App store",
          url: "https://play.google.com/store/apps/details?id=com.chapchap.merchant&pcampaignid=web_share"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/pegpay.webp"),
      projectName: "Pegpay Mobile app",
      projectDesc: "An android application that enables and supports customers to perform mobile money,bank and bill payments",
      footerLink: [
        {
          name: "Download on App store",
          url: "https://play.google.com/store/apps/details?id=ug.co.pegasus.pegpay&pcampaignid=web_share"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/ecashlogo.png"),
      projectName: "E-Cash",
      projectDesc: "A payment portal to support bulk payments to entity staff on Mobile money",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://bulkpay.stanbicbank.co.ug/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+256-785741290",
  email_address: "kampd80@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
 achievementSection,
  blogSection,
 talkSection,
 podcastSection,
  contactInfo,
 twitterDetails,
  isHireable
};
